<template>
  <div class="ha-page" style="margin-top: 180px;">
    <header class="ha-header">
      <h1 class="ha-title">Adhérer à l’association</h1>
      <p class="ha-subtitle">
        Merci pour ton soutien 💛 Ton adhésion nous aide à financer les soins, l’accueil et les actions de l’association.
      </p>

      <br>
      <div class="red_button shop_now_button buttonadaptatif bluenow"><a href="https://www.helloasso.com/associations/un-reve-un-cheval-une-famille" style="color: white !important;" target="_blank">Notre page Hello Asso</a></div>
    </header>

    <section class="ha-card">
      <div class="ha-card-top">
        <h2 class="ha-card-title">Formulaire d’adhésion</h2>
        <p class="ha-card-desc">
          Le paiement est sécurisé et géré via HelloAsso.
        </p>
      </div>

      <div class="ha-iframe-wrap">
        <iframe
          ref="haWidget"
          title="Widget HelloAsso - Adhésion"
          allowtransparency="true"
          scrolling="no"
          loading="lazy"
          :src="src"
          style="width: 100%; border: none;"
        ></iframe>
      </div>
    </section>
  </div>
</template>

<script setup>
import { onMounted, onBeforeUnmount, ref } from "vue";

const src =
  "https://www.helloasso.com/associations/un-reve-un-cheval-une-famille/adhesions/adhesion/widget";

const haWidget = ref(null);

function onMessage(e) {
  // Sécurité: on n'accepte que les messages de HelloAsso
  // (HelloAsso est hébergé sur helloasso.com)
  try {
    const originOk =
      typeof e.origin === "string" && e.origin.includes("helloasso.com");
    if (!originOk) return;

    const data = e.data;
    const height = data?.height;

    if (!haWidget.value) return;
    if (typeof height !== "number" || !Number.isFinite(height)) return;

    // petite marge pour éviter les scrollbars
    haWidget.value.style.height = `${Math.max(650, height + 20)}px`;
  } catch {
    // ignore
  }
}

onMounted(() => {
  // hauteur par défaut
  if (haWidget.value) {
    haWidget.value.style.height = "750px";
  }

  window.addEventListener("message", onMessage);
});

onBeforeUnmount(() => {
  window.removeEventListener("message", onMessage);
});
</script>

<style scoped>
.ha-page {
  padding: 24px 16px;
  max-width: 1100px;
  margin: 0 auto;
}

.ha-header {
  text-align: center;
  margin-bottom: 18px;
}

.ha-title {
  font-size: 34px;
  line-height: 1.1;
  margin: 0 0 10px;
}

.ha-subtitle {
  margin: 0 auto;
  max-width: 720px;
  font-size: 16px;
  opacity: 0.85;
}

.ha-card {
  margin: 0 auto;
  max-width: 980px;
  border: 1px solid rgba(0, 0, 0, 0.08);
  border-radius: 16px;
  background: #fff;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.06);
  overflow: hidden;
}

.ha-card-top {
  padding: 18px 18px 0;
}

.ha-card-title {
  margin: 0 0 6px;
  font-size: 20px;
}

.ha-card-desc {
  margin: 0 0 10px;
  font-size: 14px;
  opacity: 0.75;
}

.ha-iframe-wrap {
  padding: 0 12px 12px;
}

header {
    all: unset;
    /* reset total */
    display: block;
    /* remet un comportement normal */
    text-align: center;
}



@media (max-width: 600px) {
  .ha-title {
    font-size: 26px;
  }
  .ha-card {
    border-radius: 14px;
  }
  .ha-card-top {
    padding: 16px 14px 0;
  }
  .ha-iframe-wrap {
    padding: 0 8px 10px;
  }
}
</style>
